import { Image } from "native-base";
import { Link } from "react-router-dom";

const Logo = ({ w = "40", h = "78" }) => {
  return (
    <Link to="/home">
      {" "}
      <Image
        source={{
          uri: require("../quickLinkImages/ABGConnect-final-logo.jpg"),
        }}
        alt="logo"
        w={w}
        h={h}
      />
    </Link>
  );
};

export default Logo;
